import React, { useEffect, useState, useContext, useMemo } from "react";
import { Context } from "../../../context/globalContext";
import styled from "styled-components";
import axios from 'axios';
import CardContainer from '../components/CardContainer';
import AddContentModal from '../components/AddContent';
import { Modal } from 'antd';
import { ThemeProps } from '../../genericComponents/globalStyles';
import { Button } from '../../genericComponents';
import { GApageView } from "../..";
import { notificationApiURL } from '../../../helpers/initializeServices'
import firebase from "firebase/app";
import { v4 as uuidv4 } from 'uuid'
import { useQuery } from '@apollo/client';
import { NewsQueries } from '../../../helpers/GraphqlQueriesLib';
import { useAirtable } from '../hooks'
import NewsHeader from '../components/NewsHeader'
import NewsFilter from '../components/NewsFilter'

export default function NewsScreen(){
  const { graphQLClient, state: { user }} = useContext(Context);

  const [showModal, setShowModal] = useState(false)
  const [savingContent, setSavingContent] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [isShowFullDescription, setIsShowFullDescription] = useState(false)
  const [fullText, setFullText] = useState('')
  const [nextPage, fetch, { loading, data, error, lastPage }] = useAirtable(graphQLClient)
  const [categories, setCategories] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [audiences, setAudiences] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedAudience, setSelectedAudience] = useState('');
  const [selectedMediaType, setSelectedMediaType] = useState('');

  console.log("data:",data)

  useQuery(NewsQueries.GET_CATEGORIES, {
    onCompleted: data =>
      setCategories(
        data.categories.map(category => ({
          text: category.name,
          key: category.id,
          value: category.id,
        })),
      ),
  });

  useQuery(NewsQueries.GET_MEDIA_TYPES, {
    onCompleted: data =>
      setMediaTypes(
        data.media_types.map(mediaType => ({
          text: mediaType.name,
          key: mediaType.id,
          value: mediaType.id,
        })),
      ),
  });

  useQuery(NewsQueries.GET_AUDIENCES, {
    onCompleted: data =>
      setAudiences(
        data.audiences.map(audience => ({
          text: audience.name,
          key: audience.id,
          value: audience.id,
        })),
      ),
  });

  

  useEffect(() => {
    GApageView("News");
  }, []);

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  const cancelModal = () => {
    setIsShowFullDescription(false)
  }

  const finder = (parameter) => (value) => value.value == parameter

  const handlerSubmit = async (newContent, file) => {
    setSavingContent(true)
    try {
      newContent = { ...newContent, publisherEmail: user.email }
      let promises = [];
      if (file) {
        const imageKey = uuidv4(user.username + Date.now())
        newContent = { ...newContent, imageKey }
        promises.push(firebase.storage().ref(`articles/${imageKey}`).put(file))
      }
      promises.push(axios.post(`${notificationApiURL}/articles`, { article: newContent }))
      await Promise.all(promises)
    } catch (error) {
      console.log(error)
    }

    let category = categories.find(finder(selectedCategory))
    let audience = audiences.find(finder(selectedAudience))
    let mediaType = mediaTypes.find(finder(selectedMediaType))

    try {
      await fetch(searchText, category?.text, audience?.text, mediaType?.text)
    } catch (error) {
      console.log(error)
    }

    setSavingContent(false)
    toggleModal()
  }

  const handlerDescriptionClick = (fullText) => {
    setFullText(fullText)
    setIsShowFullDescription(true)
  }

  const processFetch = async (fetchFunction) => {

    try {
      let category = categories.find(finder(selectedCategory))
      let audience = audiences.find(finder(selectedAudience))
      let mediaType = mediaTypes.find(finder(selectedMediaType))

      await fetchFunction(searchText, category?.text, audience?.text, mediaType?.text);
    } catch (error) {
      console.log(error)
      throw error
    }

  }

  const handlerLoader = async () => {

    try {
      await processFetch(nextPage)
    } catch (error) {
      console.log(error)
    }
  }

  const searchContentHandler = async () => {
    try {
      await processFetch(fetch)
    } catch (error) {
      console.log(error)
    }
  }

  const handlerOnChange = async (e, data) => {
    let category, audience, mediaType;
    switch (data.id) {
      case "category":
        setSelectedCategory(data.value)
        category = categories.find(finder(data.value))
        audience = audiences.find(finder(selectedAudience))
        mediaType = mediaTypes.find(finder(selectedMediaType))
        try {
          await fetch(searchText, category?.text, audience?.text, mediaType?.text)
        } catch (error) {
          console.log(error)
        }
        break;
      case "audience":
        setSelectedAudience(data.value)
        category = categories.find(finder(selectedCategory))
        audience = audiences.find(finder(data.value))
        mediaType = mediaTypes.find(finder(selectedMediaType))
        try {
          await fetch(searchText, category?.text, audience?.text, mediaType?.text)
        } catch (error) {
          console.log(error)
        }
        break;
      case "mediaType":
        setSelectedMediaType(data.value)
        category = categories.find(finder(selectedCategory))
        audience = audiences.find(finder(selectedAudience))
        mediaType = mediaTypes.find(finder(data.value))

        try {
          await fetch(searchText, category?.text, audience?.text, mediaType?.text)
        } catch (error) {
          console.log(error)
        }
        break;
      default:
        return;

    }

  }
  const renderedCards = useMemo(() => {
    return data ?
      data.map((value, index) => (
        <CardContainer
          key={index}
          record={value}
          descriptionClick={handlerDescriptionClick} 
        />)) : []
  }, [data]);

  const clearFiltersHandler = async () => {
    setSelectedCategory('')
    setSelectedAudience('')
    setSelectedMediaType('')
    setSearchText('')
    try {
      await fetch()
    } catch (error) {
      console.log(error)
    }
  }
  const searchChangeHandler = ({ target: { value } }) => setSearchText(value);

  return (
    <>
      <Modal
        footer={null}
        visible={isShowFullDescription}
        onCancel={cancelModal}
        width={"40%"}
        centered={true}
        bodyStyle={{ backgroundColor: ThemeProps.color.softYellow }}
        style={{ minWidth: '250px' }}>

        <DescriptionContainer>
          <span>Bite Sized Bit</span>
          <div>{fullText}</div>
        </DescriptionContainer>
      </Modal>
      <NewsHeader toggleModal={toggleModal} />
      <NewsFilter
        categories={categories}
        mediaTypes={mediaTypes}
        audiences={audiences}
        onClearFilterClick={clearFiltersHandler}
        selectedMediaType={selectedMediaType}
        selectedAudience={selectedAudience}
        selectedCategory={selectedCategory}
        onDropdownChange={handlerOnChange}
        onSearchChange={searchChangeHandler}
        searchText={searchText}
        onSearchSubmit={searchContentHandler} />
      <ContentContainer>
        {renderedCards}
      </ContentContainer>
      {(data?.length > 0 && !lastPage) ? (<Footer>
        <LoadMoreContent onClick={handlerLoader}>Load More</LoadMoreContent>
      </Footer>) : null}
      <AddContentModal
        isShow={showModal}
        onHide={toggleModal}
        addNewContent={handlerSubmit}
        savingContent={savingContent}
        categories={categories}
        mediaTypes={mediaTypes}
        audiences={audiences} 
      />
    </>
  );
};


const Footer = styled.div`
  width:100%;
`

const LoadMoreContent = styled(Button)`
  margin:0px auto;
  display:block;
`

const Container = styled.div`
  padding: 0px 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;

`

const ContentContainer = styled(Container)`
  align-items: flex-start;
  align-content: flex-start;
  margin: 10px auto 5px auto;
`

const DescriptionContainer = styled.div`
    padding:10px;
    flex-flow: column nowrap;
    display:flex;
    
    justify-content: flex-start;
    span {
        background:${ThemeProps.color.softPurple};
        color: ${ThemeProps.color.darkBlue};
        font-size: 1.2em;
        border-radius: 3px;        
        padding:5px 10px;
        width:140px;
        margin-bottom:15px;
        font-weight:bold;    
    }
    div{
      max-height:300px;
      overflow-y:scroll;
    }
`;